import { createStore, applyMiddleware } from 'redux';
import ShopApp from '../reducers/index'
const store =  createStore(ShopApp);
export default store;